import React from "react";

import { Drawer } from "../../../components/Drawer";
import { Button } from "../../../components/Button";

import styles from "../../../../styles/blocked-customers.module.scss";
import { EnvironmentsAPI } from "../../../../providers/EnvironmentsAPI";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { Select } from "../../../components/Select";

const CASHBACK_USE_FORMAT = {
	GIFT: "GIFT",
	PAYMENT: "PAYMENT",
}

export default class CashbackConfigurations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFormat: null,
      loading: false,
    };
  }

  async componentDidMount() {
    const environmentId = await EnvironmentStorage.getSelectedEnvironment();

	const cashbackConfiguration = await EnvironmentsAPI.getConfigurationsByAlias(
		environmentId,
		"cashback_use",
	  );

	this.setState({
		selectedFormat: cashbackConfiguration?.format || null
	})
  }

  async save() {
    const { selectedFormat } = this.state;

    this.setState({ loading: true });
    const environmentId = await EnvironmentStorage.getSelectedEnvironment();

    const configurationResponse = await EnvironmentsAPI.putConfigurationsByAlias(
		environmentId,
      "cashback_use",
      {
        cashback_use: {
			format: selectedFormat,
		}
      }
    );

    if (configurationResponse.getErrors([]).length > 0) {
      alert({
        text: configurationResponse.getErrors()[0],
        buttonText: "Ok",
      });
      this.setState({ loading: false });
      return false;
    }

    alert({
      text: "Configurações alteradas sucesso",
      buttonText: "Ok",
    });

    this.setState({ loading: false });
    return true;
  }

  render() {
    const { visible, onClose } = this.props;
    const { selectedFormat, loading } = this.state;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title="Configurações de Cashback"
      >
         <Select
			value={selectedFormat}
			design="two"
			className="flex-1"
			label="Utilizar saldo de cashback como"
			options={
				[
					{ value: null, label: null },
					{ value: CASHBACK_USE_FORMAT.GIFT, label: "Benefício" },
					{ value: CASHBACK_USE_FORMAT.PAYMENT, label: "Pagamento" },
				]
			}
			onChange={(e) => {
				this.setState({
					selectedFormat: e.target.value
				})
			}}
			/>
        <div className={styles.footer}>
          <Button
            className="w-100"
            design="primary"
            disabled={loading}
            loading={loading}
            onClick={() => this.save()}
          >
            Salvar
          </Button>
        </div>
      </Drawer>
    );
  }
}
